const ar = {
  /** Global */
  WELCOME: "أهلًا وسهلًا",
  HI: "مرحبًا",
  LANG: "العربية",
  BACK_TO_HOME_PAGE: "العودة إلى الصفحة الرئيسية",
  INSTALL_APP: "تحميل التطبيق",
  NUM_IS_GREATER_ERROR: "أدخل رقمًا أقل من",
  NUM_IS_LESS_ERROR: "أدخل رقمًا أكبر من",
  DETAILS: "التفاصيل",
  CLEAR: "إعادة تعيين",
  SAVE: "حفظ",
  UPLOAD: "رفع",
  NEW: "جديد",
  CANCEL: "إلغاء",
  EDIT: "تعديل",
  DELETE: "حذف",
  LOGOUT: "تسجيل الخروج",
  ACCEPT: "موافقة",
  ERROR: "خطأ",
  CLOSE: "إغلاق",
  GOOD_AFTERNOON: "مساء الخير",
  GOOD_EVENING: "مساء الخير",
  GOOD_NIGHT: "تصبح على خير",
  GOOD_MORNING: "صباح الخير",
  PATH_EXISTS: "المعرّف موجود بالنظام - يُرجى اختيار معرف آخر",
  CREATED: "تاريخ الإنشاء",
  NO_DATA: "لا توجد بيانات لعرضها",
  QTY: "الكمية",
  TYPE: "النوع",
  PRICE: "السعر",
  TEMPLATES: "التصميم",
  SEND: "إرسال",
  REFRESH: "تحديث",
  SEARCH: "بحث",
  SAVED_SUCCESS: "تم الحفظ بنجاح",
  LINK_COPY_SUCCESS: "تم نسخ الرابط بنجاح",
  UNLIMITED: "غير محدود",
  ADMIN_AREA: "منطقة الإدارة",
  FREE: "مجاني",
  REMOVE: "إزالة",
  CONTINUE: "متابعة",
  DELETE_INFO: "يرجى الانتباه - بعد الحذف لا يمكن استرجاع هذه البيانات",
  DOWNLOAD: "تنزيل",
  PAY_ATTENTION: "يرجى الانتباه",
  SHOW: "عرض",
  DATE: "التاريخ",
  SUNDAY: "الأحد",
  MONDAY: "الاثنين",
  TUESDAY: "الثلاثاء",
  WEDNESDAY: "الأربعاء",
  THURSDAY: "الخميس",
  FRIDAY: "الجمعة",
  SATURDAY: "السبت",
  HELLO: "أهلًا",
  LAST_ACTIVE: "آخر نشاط",
  COLOR: "اللون",
  EMPLOYEE: "موظف",
  DEPARTMENT_MANAGER: "مدير القسم",
  BIZ_MANAGER: "مدير العمل",
  ROLE: "الصلاحيات",
  LINK_COPY_SUCCESSFULLY: "تم نسخ الرابط بنجاح",
  TABLE: "جدول",
  CARDS: "بطاقات",
  STATUS: "الحالة",
  ADD: "إضافة",
  ALL: "الكل",
  FULL: "ممتلئ",
  EMPTY: "فارغ",
  GLOBAL: "عام",
  EMP_AND_DATES: "التوظيف والمواعيد",
  PAYMENTS: "الدفعات",
  EMPLOYEE_NAME: "اسم الموظف المنفذ",
  CREATE_GUID: "إنشاء معرّف",
  CHECK_CONNECTED: "تحقق من الاتصال",
  NETWORK_CONNECTION_GUIDE_TITLE: "اتصال المستشعر بالشبكة",
  NETWORK_CONNECTION_GUIDE_1: "ادخل إلى إعدادات الشبكات اللاسلكية بهاتفك أو جهاز الكمبيوتر",
  NETWORK_CONNECTION_GUIDE_2: "ابحث عن شبكة باسم 'MyBee'",
  NETWORK_CONNECTION_GUIDE_3: "اضغط على اتصال وأدخل كلمة المرور الموجودة على المستشعر",
  NETWORK_CONNECTION_GUIDE_4: "بعد ذلك ستفتح لك صفحة اتصال",
  NETWORK_CONNECTION_GUIDE_4_1: "إذا لم تفتح الصفحة اضغط هنا",
  NETWORK_CONNECTION_GUIDE_5: "أدخل تفاصيل اتصال الشبكة (اسم الشبكة وكلمة المرور)",
  NETWORK_CONNECTION_GUIDE_6: "أرسل النموذج وانتظر اتصال المستشعر بالشبكة",
  NETWORK_CONNECTION_GUIDE_7: "اضغط على تحقق من الاتصال أسفل الصفحة",
  SET_ALL_ASTERISK_ERROR: "يرجى ملء كافة الحقول المميزة بـ *",
  TEST: "اختبار",
  WS_IS_CONNECTED: "متصل بالخلية",
  WS_IS_DISCONNECTED: "غير متصل بالخلية",
  NUMBER_MUST_BE_BETWEEN: "يجب أن يكون الرقم بين",
  NUMBER_MUST_BE_GREATER_THAN: "يجب أن يكون الرقم أكبر من",
  NUMBER_MUST_BE_LESS_THAN: "يجب أن يكون الرقم أقل من",
  SETTINGS_AND_ADMIN: "الإعدادات والإدارة",
  NO_PLUGIN: "غير مصرح بفتح بلاغ - يُرجى التواصل مع خدمة العملاء لمزيد من المعلومات",
  HAS_TWO_FACTOR: "تفعيل التحقق بخطوتين",
  TWO_FACTOR_NEED_EMAIL_ERROR: "يجب إضافة بريد إلكتروني لتفعيل التحقق بخطوتين",
  TWO_FACTOR_CODE: "رمز التحقق بخطوتين",
  CODE: "أدخل الرمز الذي تم إرساله",
  TWO_FACTOR_SEND_EMAIL: "تم إرسال رمز التحقق إلى البريد الإلكتروني",
  TWO_FACTOR_INPUT: "يُرجى إدخال الرمز لإتمام العملية",
  TWO_FACTOR_CODE_REQUIRED: "إدخال رمز التحقق إلزامي",
  SEND_AGAIN_TIMER: "لم أحصل على رمز",
  SEND_AGAIN: "أرسل الرمز مرة أخرى",
  SEND_CODE_SUCCESS: "تم إرسال الرمز بنجاح",
  SELECTED_LANG: "اختيار اللغة",
  LANGUAGE: "اللغة",
  HE: "العبرية",
  EN: "الإنجليزية",
  AR: "العربية",
  RU: "الروسية",
  CHANGE_LANG_SUCCESS: "تم تغيير اللغة بنجاح",
  CHANGE_LANG_ERROR: "لم نتمكن من تغيير اللغة، يرجى المحاولة مرة أخرى",
  ICON: "أيقونة",
  TITLE: "عنوان",
  URL: "رابط الموقع",

  /** Validations */
  REQUIRED: "حقل إلزامي",
  URL_ERROR: "يُرجى إدخال عنوان URL صحيح، مثل: https://www.google.com",
  CEL_ISRAELI_ERROR: "يُرجى إدخال رقم هاتف صحيح",
  EMAIL_ERROR: "يُرجى إدخال بريد إلكتروني صحيح",
  ONLY_NUMBER_ERROR: "يُرجى إدخال أرقام فقط",
  PATH_ERROR: "يُرجى إدخال حروف إنجليزية وأرقام (بين 3 و 20 حرفًا)",
  PASSWORD_ERROR: "يجب أن تكون كلمة المرور 8 أحرف على الأقل، تتضمن حرفًا كبيرًا وصغيرًا ورقمًا ورمزًا خاصًا",

  /** Plans */
  PLANS_MANAGEMENT: "إدارة الخطط",
  servicesCall: "بلاغات الخدمة",
  contactUs: "البريد",
  schedule: "جدول المواعيد",
  PLANS: "الخطط",
  maxClients: "عدد العملاء",
  maxEmployees: "عدد الموظفين",
  maxItems: "عدد المنتجات",
  maxWebAppMessage: "عدد الرسائل",
  EVERY_MONTH: "شهريًا",
  SELECT_PLAN: "اختر الخطة",
  ONLY_SYS_ADMIN: "يظهر لمسؤولي النظام فقط",
  SYS_NAME: "الاسم في النظام",

  /** Dates Reports */
  DATES: "التقويم",
  START_DATE: "تاريخ البداية",
  END_DATE: "تاريخ الانتهاء",
  CREATE_REPORT: "إنشاء تقرير",
  TODAY: "اليوم",
  THIS_WEEK: "هذا الأسبوع",
  THIS_MONTH: "هذا الشهر",
  THIS_YEAR: "هذا العام",
  ALL_EMPLOYEES: "جميع الموظفين",
  PMT_TYPE: "حالة الدفع",
  ALL_PMT: "جميع أنواع الدفع",
  ALL_STATUS: "جميع الحالات",

  /** Login */
  LOGIN: "تسجيل الدخول",
  CONNECT: "اتصل",
  USER_NAME: "اسم المستخدم",
  PASSWORD: "كلمة المرور",
  HAS_SIGNIN: "ليس لديك حساب بعد؟",
  SIGNIN_NOW: "افتح حسابًا",
  KEEP_LIGIN: "تذكرني على هذا الجهاز",
  REMEMBER_ME: "تذكرني",
  LOGIN_ERROR: "خطأ في تسجيل الدخول",
  LOGIN_SUCCESS: "تم تسجيل الدخول بنجاح",

  /** Recommend */
  RECOMMEND: "التوصيات",
  RECOMMEND_DESC: "وصف التوصية",

  /** Templates */
  BASIC: "أساسي",
  CLASSIC: "كلاسيكي",
  WAVES: "أمواج",
  BUBBLE: "فقاعات",
  TEMP_TYPE_ID: "اختر التصميم",
  CLASSIC_1: "كلاسيكي 1",
  DESIGN_1: "تصميم 1",

  /** Signup */
  SIGNUP: "هيا نبدأ",
  WELCOME: "أهلًا وسهلًا",
  SIGNUP_NFO: "تسجيل سريع وستكون بالداخل",
  USER_DETAILS: "تفاصيل المستخدم",
  BIZ_DETAILS: "تفاصيل العمل",
  BIZ_TEL: "هاتف العمل",
  BIZ_EMAIL: "البريد الإلكتروني للعمل",
  BIZ_DESC: "بعض المعلومات عن العمل",
  VALID_PASSWORD: "تأكيد كلمة المرور",
  EMAIL_FOR_RESET_PASSWORD: "البريد الإلكتروني لاستعادة كلمة المرور",
  HAS_LOGIN: "لديك حساب بالفعل؟",

  /** businessCard */
  businessCard: "بطاقة عمل",

  /** Analytics */
  ANALYTICS: "تحليلات",

  /** Private Area */
  PRIVATE_AREA: "المنطقة الشخصية",

  /** Plans */
  PLANS_MANAGEMENT: "إدارة الخطط",
  servicesCall: "نداءات الخدمة",
  contactUs: "البريد",
  schedule: "جدول المواعيد",
  PLANS: "خطط",
  maxClients: "عدد العملاء",
  maxEmployees: "عدد الموظفين",
  maxItems: "عدد المنتجات",
  maxWebAppMessage: "عدد الرسائل",
  EVERY_MONTH: "شهريًا",
  SELECT_PLAN: "اختر خطة",
  ONLY_SYS_ADMIN: "يظهر فقط لمسؤولي النظام",
  SYS_NAME: "اسم في النظام",

  /** Dates Reports */
  DATES: "التقويم",
  START_DATE: "تاريخ البدء",
  END_DATE: "تاريخ الانتهاء",
  CREATE_REPORT: "إنشاء تقرير",
  TODAY: "اليوم",
  THIS_WEEK: "هذا الأسبوع",
  THIS_MONTH: "هذا الشهر",
  THIS_YEAR: "هذا العام",
  ALL_EMPLOYEES: "جميع الموظفين",
  PMT_TYPE: "حالة الدفع",
  ALL_PMT: "جميع أنواع الدفع",
  ALL_STATUS: "جميع الحالات",

  /** Login */
  LOGIN: "تسجيل الدخول",
  CONNECT: "تسجيل الدخول",
  USER_NAME: "اسم المستخدم",
  PASSWORD: "كلمة المرور",
  HAS_SIGNIN: "ليس لديك حساب بعد؟",
  SIGNIN_NOW: "افتح حسابًا",
  KEEP_LIGIN: "تذكرني على هذا الجهاز",
  REMEMBER_ME: "تذكرني",
  LOGIN_ERROR: "خطأ في تسجيل الدخول",
  LOGIN_SUCCESS: "تم تسجيل الدخول بنجاح",

  /** Recommend */
  RECOMMEND: "التوصيات",
  RECOMMEND_DESC: "وصف التوصية",

  /** Templates */
  BASIC: "أساسي",
  CLASSIC: "كلاسيكي",
  WAVES: "أمواج",
  BUBBLE: "فقاعات",
  TEMP_TYPE_ID: "اختر تصميم",
  CLASSIC_1: "كلاسيكي 1",
  DESIGN_1: "تصميم 1",

  /** Signup */
  SIGNUP: "لنبدأ!",
  WELCOME: "مرحبًا بكم",
  SIGNUP_NFO: "تسجيل قصير وستكون في الداخل",
  USER_DETAILS: "تفاصيل المستخدم",
  BIZ_DETAILS: "تفاصيل العمل",
  BIZ_TEL: "هاتف العمل",
  BIZ_EMAIL: "البريد الإلكتروني للعمل",
  BIZ_DESC: "معلومات عن العمل",
  VALID_PASSWORD: "تأكيد كلمة المرور",
  EMAIL_FOR_RESET_PASSWORD: "البريد الإلكتروني لاستعادة كلمة المرور",
  HAS_LOGIN: "لديك حساب بالفعل؟",

  /** businessCard */
  businessCard: "بطاقة أعمال",

  /** Analytics */
  ANALYTICS: "تحليلات",

  /** Private Area */
  PRIVATE_AREA: "منطقة خاصة",

  /** plans */
  MAX_CLIENTS: "عدد العملاء",
  MAX_EMPLOYEES: "عدد الموظفين",
  MAX_ITEMS: "عدد المنتجات",
  MAX_WEBAPPMESSAGE: "عدد الرسائل",
  YOUR_PLAN: "خطة عملك",
  DELETE_PLAN: "هل أنت متأكد أنك تريد حذف هذه الحزمة؟",

  /** plugins */
  PLUGINS: "الإضافات",
  PLUGINS_MANAGER: "إدارة الإضافات",
  MAX_QTY: "الكمية القصوى",
  PROPERTIES: "الخصائص",
  SELECT_PLUGIN: "أضف إضافة",
  REMOVE_PLUGIN: "إزالة إضافة",
  REMOVE_PLUGIN_ASK: "هل أنت متأكد أنك تريد إزالة",
  REMOVE_PLUGIN_INFO: "سيتم حفظ بياناتك ولكن لن تكون لديك صلاحية الوصول إليها أو استخدام ميزات هذه الإضافة",
  REMOVE_AFTER_SAVE: "تنبيه - سيتم إزالة الإضافة فقط بعد النقر على زر المتابعة",
  DELETE_PLUGIN: "هل أنت متأكد أنك تريد حذف هذه الإضافة؟",

  /** desktop */
  DASHBOARD: "لوحة التحكم",
  STATUS_SERVICES_CALL: "حالة نداءات الخدمة",
  SUM: "المجموع",
  NOT_WORK_DT: "بدون تاريخ عمل",
  NO_INVOICE_NUMBER: "بدون فاتورة",
  TOTAL_EXPENSES_PROVIDERS: "نفقات الموردين",
  TOTAL_REVENUE: "إجمالي الإيرادات",
  REVENUE: "الإيرادات",

  /** Business */
  COLOR1: "اللون 1",
  COLOR2: "اللون 2",
  COLOR3: "اللون 3",
  LOGO: "شعار",
  IMAGE_HEADER: "صورة الغلاف للصفحات المقصودة",
  LAT_AND_LON: "خط الطول والعرض",
  DESC_BIZ_TITLE: "عنوان لوصف العمل",
  DESC_BIZ: "وصف العمل",
  IS_EXAMPLE: "عمل تجريبي",

  /** Departments */
  DEPARTMENTS: "الأقسام",
  DEPARTMENT: "قسم",
  MANAGER: "مدير",
  PLUGINS_LIST: "قائمة الإضافات",
  ADD_PLUGINS: "أضف إضافة",
  SELECT_PLUGINS: "اختر إضافة",
  LINKED_PLUGINS: "الإضافات المرتبطة",

  /** Employee */
  EMPLOYEES: "الموظفون",
  EMPLOYEE: "موظف",
  ALL_EMPLOYEES: "جميع الموظفين",
  EMPLOYEE_IMG: "صورة الموظف",
  CARDS: "بطاقات",
  CARD: "بطاقة",
  EMPLOYEE_DETAILS: "تفاصيل الموظف",
  FN: "الاسم الأول",
  LN: "اسم العائلة",
  BIZ_ROLE: "الدور",
  TEL: "هاتف",
  EMAIL: "البريد الإلكتروني",
  OF: "من",
  CARD_QTY: "عدد البطاقات",
  EMPLOYEES_QTY: "عدد الموظفين",
  EMPLOYEES_PATH: "معرف الموظف",
  BUSINESS_CARD: "بطاقة الأعمال",
  WEB_APP_PAGE: "صفحة مقصودة",
  LOGIN_EMP: "تسجيل دخول الموظف",
  LOGIN_EMP_LINK: "رابط تسجيل دخول الموظف",
  OPEN_LINK: "افتح الرابط",
  COPY_LINK: "نسخ الرابط",
  USER_NAME_EXISTS: "اسم المستخدم موجود بالفعل - يرجى اختيار اسم آخر",
  DELETE_EMPLOYEES: "هل أنت متأكد أنك تريد حذف هذا الموظف؟",
  IS_BO_ALLOWED: "الوصول إلى لوحة الإدارة",
  HAS_WEB: "صفحة الموظف",
  LOGIN_EMP_LINK_INFO: "الرابط شخصي وغير قابل للنقل (لكل موظف رابط مختلف)",

  /** items */
  SKU: "كود المنتج",
  DESC: "الوصف",
  IS_WEB_SALE: "ظاهر على الموقع",
  NAME: "الاسم",
  WARRANTY_TIME: "مدة الضمان (بالأيام)",
  DELETE_ITEM: "هل أنت متأكد أنك تريد حذف هذا المنتج؟",
  ITEMS_QTY: "عدد المنتجات",
  ITEM_DETAILS: "تفاصيل المنتج",

  /** Clients */
  CLIENTS: "العملاء",
  GET_CLIENTS_ERROR: "خطأ في استيراد العملاء",
  CLIENT_GUID: "معرف العميل",
  COMPANY: "اسم الشركة",
  CONTACT_NAME: "جهة الاتصال",
  CLIENT_DETAILS: "تفاصيل العميل",
  GUID_EXISTS: "المعرف موجود بالفعل، يرجى اختيار معرف آخر",
  CLIENT_QTY: "عدد العملاء",
  ITEMS_LIST: "قائمة المنتجات",
  ADD_ITEM: "أضف منتج",
  ITEMS: "المنتجات",
  NEW_CLIENT: "عميل جديد",
  GUID: "المعرف",
  SELECT_ITEM: "اختر منتج",
  DELETE_CLIENT: "هل أنت متأكد أنك تريد حذف هذا العميل؟",
  ALL_CLIENTS: "جميع العملاء",
  IS_BLOCKED: "عميل محظور",

  /** Services call */
  SERVICE_CALL_ACTIVE: "طلبات نشطة",
  SERVICE_CALL_APPROVAL: "طلبات مغلقة",
  SERVICE_CALL_HISTORY: "سجل",
  SERVICES_CALL: "طلب/حجز",
  CALL_ID: "رقم الطلب",
  OPEN: "مفتوح",
  SELECT_EMPLOYEE: "موظف مرتبط",
  PMT_TYPE_ID: "حالة الفوترة",
  PAY: "مدفوع",
  NOT_PAY: "غير مدفوع",
  SERVICE: "خدمة",
  WAITING: "انتظار",
  NOTES: "ملاحظات",
  CLIENT_CALL_ID: "رقم الطلب (عميل)",
  ALL_CALLS: "جميع الطلبات",
  JOB_DONE_DESC: "العمل المنجز",
  SELECT_EMP: "اختر موظف",
  DESC_PROBLEM: "وصف المشكلة",
  CREATE_SERVICES: "فتح طلب جديد",
  IMPORT_CALL: "استيراد طلبات",
  NEW_CALL: "طلب جديد",
  RESET: "إعادة تعيين",
  DELETE_SERVICES_CALL: "هل أنت متأكد أنك تريد حذف هذا الطلب؟",
  WORK_DT: "تاريخ العمل",
  DODAY: "اليوم",
  CLIENT_NAME: "جهة اتصال",
  ORDER_NUM: "رقم الحجز",
  INVOICE_NUM: "رقم الفاتورة",
  QUOTATION_NUM: "رقم الاقتراح",
  CREATE_QR: "إنشاء QR",
  S_C: "ط.خ",
  DISPLAY_SETTINGS: "إعدادات العرض",
  PROVIDERS: "موردون",
  CONTENT_WITH_ITEMS: "وصف المشكلة",
  SEND_SEVICES_SUMMARY: "إرسال ملخص الزيارة",
  OPEN_SEVICES_SUMMARY: "فتح ملخص الزيارة",
  CLIENT_NO_EMAIL: "لا يمكن الإرسال - لا يحتوي العميل على بريد إلكتروني",
  CHANGE_DATES: "تغيير التواريخ",
  START: "بداية",
  END: "نهاية",
  PROVIDERS_EXPENSES: "نفقات الموردين",
  SEND_SUCCESS: "تم إرسال ملخص الزيارة بنجاح",
  WORK_END_DT: "انتهاء العمل",
  WORK_END_DT_ISBEFORE_WORK_DT_ERROR: "تاريخ الانتهاء لا يمكن أن يكون قبل تاريخ البدء",
  SUBMIT_AND_SEND_SUMMARY: "احفظ وأرسل",
  APPROVAL: "موافقة",
  SELECT_DEPARTMENTS: "اختر قسمًا",
  SELECT_CLIENT: "اختر عميلًا",
  CREATE_SERVICE_CALL: "فتح طلب خدمة",

  /** Control And Monitoring */
  CONTROL_AND_MONITORING: "التحكم والمراقبة",
  TEMP1: "هواء راجع",
  TEMP2: "هواء خارج",
  LOADING_TO_DATA: "انتظار...",
  ACTIVE_DATA: "حالة المكيف",
  ON_MC: "نشط",
  OFF_MC: "متوقف",
  TEMP_ACTIVE: "درجة الحرارة",
  MODE_ACTIVE: "الوضع",
  TURN_ON_DATE: "تاريخ التشغيل",
  FAULT: "عطل",
  FAULTS: "أعطال",
  CLOGGED_FILTER: "يبدو أن الفلتر مسدود - يُنصح بتنظيفه",
  SENSOR_ERROR: "أحد المستشعرات معطل - يُرجى الاتصال بخدمة العملاء",
  LACK_GAS: "يبدو أن هناك نقصًا في الغاز - يُنصح بفتح طلب فني",
  COMPRESSOR_NOT_STOP: "الضاغط لا يتوقف - يُرجى فحص المكيف فورًا",
  TURN_ON_DATE_INFO_RELAY: "هل أنت متأكد أنك تريد تشغيل الجهاز؟",
  TURN_OFF_DATE_INFO_RELAY: "هل أنت متأكد أنك تريد إيقاف الجهاز؟",
  ALL_AREAS: "جميع المناطق",
  MC_IS_DISCONNECTED: "وحدة التحكم غير متصلة بالشبكة",

  /** Calendar */
  CALENDAR: "تقويم",
  LOCATION: "الموقع",
  AVAILABILITY: "التوفر",
  AVAILABLE: "متاح/ة",
  BUSY: "مشغول/ة",
  PERSONAL: "شخصي",
  VOLUNTEERING: "تطوع",
  SCHOOL: "دراسة",
  WORK: "عمل",
  FAMILY: "عائلة",
  DELETE_EVENT: "هل أنت متأكد أنك تريد حذف هذا الحدث؟",

  /** Meter Reading */
  METER_READING: "قراءة العدادات",
  METER_ID: "رقم العداد",
  READ_VALUE: "قراءة",
  ELECTRICITY: "كهرباء",
  WATER: "مياه",
  GAS: "غاز",
  METER_READ: "قراءة العداد",
  DELETE_METER_READ: "هل أنت متأكد أنك تريد حذف هذه القراءة؟",
  CREATED_READ: "تاريخ القراءة",
  METER_LAST_READ: "آخر قراءة للعداد",
  ERROR_DAY: "تمت القراءة اليومية",

  /** meter */
  METER_NAME: "اسم/رقم العداد",
  METERS: "عدادات",
  THERE_ARE_NO_METERS: "لا توجد عدادات متاحة للقراءة، يُرجى فتح عداد قبل القراءة",
  SELECT_METER: "اختر عدادًا",

  /** Settings */
  BIZ_SETTINGS: "إعدادات العمل",
  BIZ_NAME: "اسم العمل",
  ADDR: "عنوان",

  /** contact us */
  CONTACT_US: "اتصل بنا",

  /** Smart Qr */
  SMART_QR: "Smart QR",
  CONTACT: "جهة اتصال",
  CLIENT_SERVICES_CALL: "طلبات خدمة للعميل",
  QR_DETAILS: "تفاصيل",
  CLIENT_ITEM: "منتج",
  CLIENT: "عميل",
  TITLE_QR: "عنوان (للاستخدام الداخلي)",
  DELETE_SMART_QR: "هل أنت متأكد أنك تريد حذف هذا Smart QR؟",
  TEXT: "نص",
  LOCATION: "الموقع",
  NAVIGATION: "ملاحة",
  HAS_PASSWORD: "محمٍ بكلمة مرور",

  /** Appointments */
  APPOINTMENTS: "جدولة المواعيد",

  /** Schedule */
  SCHEDULE: "الجدول الزمني",

  /** video Carousel */
  VIDEO_CAROUSEL: "شريط فيديو متحرك",
  VIDEO: "فيديو",
  VIDEO_QTY: "عدد مقاطع الفيديو",
  VIDEO_URL: "رابط الفيديو",

  /** Micro Controllers Manager */
  MICRO_CONTROLLERS_MANAGER: "إدارة وحدات التحكم",
  MICRO_CONTROLLERS: "وحدات تحكم",
  MICRO_CONTROLLER: "وحدة تحكم",
  MICRO_CONTROLLER_DETAILS: "تفاصيل وحدة التحكم",
  AIR_CONDITIONER: "مكيف",
  LIGHTING: "إضاءة",
  IS_LINKED_MC: "مرتبط بوحدة تحكم (وحدة برمز معرف)",
  MC_NOT_FOUND: "لم يتم العثور على وحدة التحكم",
  CHECK_ACTIVATED: "فحص وحدة التحكم",
  MC_HAPPY: "وحدة تحكم سليمة",
  MICRO_CONTROLLER_CREATE: "إنشاء وحدة تحكم",
  DELETE_MICRO_CONTROLLER: "هل أنت متأكد أنك تريد حذف هذه الوحدة؟",
  ACTIVATED: "نشط",
  MINI_DETAILS: "تفاصيل مبدئية",
  CONNECT_TO_WIFI: "الاتصال بالشبكة",
  MC_CONNECTED: "وحدة التحكم متصلة بالشبكة",
  MC_DISCONNECTED: "وحدة التحكم غير متصلة بالشبكة",
  MC_ACTIVATED: "وحدة تحكم قيد الاستخدام",
  OUTSIDE_WORKING_HOURS: "خارج ساعات العمل",
  OUTSIDE_WORKING_HOURS_MSG: "يبدو أنك تحاول تشغيل الجهاز خارج ساعات العمل",
  OUTSIDE_WORKING_HOURS_MSG_1: "اضغط على الوقت الذي ترغب في تشغيل الجهاز فيه",
  ONE_HOUR: "ساعة واحدة",
  TWO_HOURS: "ساعتان",
  THREE_HOURS: "ثلاث ساعات",
  FOUR_HOURS: "أربع ساعات",

  /** Areas */
  AREAS: "مناطق",
  AREA: "منطقة",
  DELETE_AREA: "هل أنت متأكد أنك تريد حذف هذه المنطقة؟",

  /** Webapp Message */
  WEBAPP_MESSAGE: "بريد",
  OPEN_MESSAGE: "فتح رسالة",
  FULL_NAME: "جهة اتصال",
  IS_READ: "حالة الرسالة",
  MESSAGE: "رسالة",
  READ: "رسالة مقروءة",
  NOT_READ: "رسالة غير مقروءة",
  SELECTED_EMP: "اختر موظف",

  /** business manager */
  BUSINESS_MANAGER: "إدارة الأعمال",
  NAVIGATE_BUSINESS: "الانتقال إلى العمل",
  PATH: "معرف",

  /** Ac Commands */
  BRAND: "علامة تجارية",
  MODEL: "طراز",
  VERSION: "إصدار",
  YEAR_MANUFACTURE: "سنة الصنع",
  REGION: "المنطقة",
  ON: "تشغيل",
  OFF: "إيقاف",
  VENT: "تهوية",
  COOL: "تبريد",
  HEAT: "تدفئة",
  DRY: "تجفيف",
  AUTO: "تلقائي",
  ECO: "اقتصادي",
  SLEEP: "نوم",
  TURBO: "توربو",
  DEGREES: "درجات",
  PROTOCOL: "بروتوكول",
  BITS: "عدد البتات",
  MODES: "أنماط التشغيل",
  POWER: "تشغيل وإيقاف",
  POWER_COMMANDS: "تشغيل وأنماط العمل",
  TEMPS_COMMANDS: "درجة الحرارة",
  AC_COMMANDS_MANAGER: "أوامر المكيف",
  FAN_SPEED: "سرعة المروحة",
  LOW: "منخفض",
  MEDIUM: "متوسط",
  HIGH: "مرتفع",
  COMMANDS: "أوامر",
  SELECT_COMMAND: "تحديد الأوامر (عادةً حسب العلامة التجارية والطراز)",
  TEST_COMMAND_SUCCESS: "تم إرسال اختبار إلى وحدة التحكم - إذا استقبل المكيف الأمر، يجب أن يعمل",
  COMMAND_NOE_FOUND_ERROR: "يجب اختيار علامة تجارية للمكيف",
  WEEKLY_TIMES: "جدول أسبوعي",
  RELAY: "مرحّل",
  DIFFERENCE: "فرق",

  /** reports */
  REPORTS: "تقارير",
  INVOICE_STATUS: "حالة رقم الفاتورة",

  /** colors name */
  LIGHT_PINK: "وردي فاتح",
  LIGHT_YELLOW: "أصفر فاتح",
  PALE_GREEN: "أخضر باهت",
  LIGHT_BLUE: "أزرق فاتح",
  OFF_WHITE: "أبيض كريمي",
  LIGHT_LAVENDER: "لافندر فاتح",
  SOFT_RED: "أحمر ناعم",
  SOFT_CYAN: "سماوي ناعم",
  SOFT_GOLD: "ذهبي ناعم",
  SOFT_MINT: "نعناع ناعم",
  SOFT_LILAC: "أرجواني ناعم",
};

export default ar;
